import { useAuthorizedIntegrationContext } from '@shared/contexts/pluginContexts/AuthorizedIntegrationContext';
import { useEmailThreadContext } from '@shared/contexts/pluginContexts/EmailThreadContext';
import { FeedSuggestedActions } from '@shared/plugin/features/Feed';
import { SharedInboxNotice } from '@shared/plugin/pages/Home/components/SharedInboxNotice';
import { ReactNode } from 'react';
import { EmailThreadFeedProvider } from './EmailThreadFeedProvider';
import { EmailThreadFeedSection } from './EmailThreadFeedSection';

export function ChatsPageWithEmailFeed({ children }: { children: ReactNode }) {
  const { authorized } = useAuthorizedIntegrationContext();
  const { thisItem } = useEmailThreadContext();
  const hasOpenEmail = authorized && Boolean(thisItem?.id);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      {hasOpenEmail && (
        <EmailThreadFeedProvider>
          <>
            <EmailThreadFeedSection />
            <SharedInboxNotice />
            <FeedSuggestedActions />
          </>
        </EmailThreadFeedProvider>
      )}
    </div>
  );
}
